/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const searchLDSproperties = /* GraphQL */ `
  query SearchLDSproperties(
    $filter: SearchableLDSpropertyFilterInput
    $sort: [SearchableLDSpropertySortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableLDSpropertyAggregationInput]
  ) {
    searchLDSproperties(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        APN
        AssetCategory
        LandUseDescription
        Address
        City
        State
        Zip
        County
        GPS
        Acreage
        TaxYear
        TotalAssessedValue
        TotalMarketValue
        ReportedOwner
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
            }
          }
        }
      }
    }
  }
`;
export const getLDSproperty = /* GraphQL */ `
  query GetLDSproperty($id: ID!) {
    getLDSproperty(id: $id) {
      id
      APN
      AssetCategory
      LandUseDescription
      Address
      City
      State
      Zip
      County
      GPS
      Acreage
      TaxYear
      TotalAssessedValue
      TotalMarketValue
      ReportedOwner
      createdAt
      updatedAt
    }
  }
`;
export const listLDSproperties = /* GraphQL */ `
  query ListLDSproperties(
    $filter: ModelLDSpropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLDSproperties(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        APN
        AssetCategory
        LandUseDescription
        Address
        City
        State
        Zip
        County
        GPS
        Acreage
        TaxYear
        TotalAssessedValue
        TotalMarketValue
        ReportedOwner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const lDSpropertiesByCityAndTotalAssessedValue = /* GraphQL */ `
  query LDSpropertiesByCityAndTotalAssessedValue(
    $City: String!
    $TotalAssessedValue: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLDSpropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    LDSpropertiesByCityAndTotalAssessedValue(
      City: $City
      TotalAssessedValue: $TotalAssessedValue
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        APN
        AssetCategory
        LandUseDescription
        Address
        City
        State
        Zip
        County
        GPS
        Acreage
        TaxYear
        TotalAssessedValue
        TotalMarketValue
        ReportedOwner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const lDSpropertiesByStateAndTotalAssessedValue = /* GraphQL */ `
  query LDSpropertiesByStateAndTotalAssessedValue(
    $State: String!
    $TotalAssessedValue: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLDSpropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    LDSpropertiesByStateAndTotalAssessedValue(
      State: $State
      TotalAssessedValue: $TotalAssessedValue
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        APN
        AssetCategory
        LandUseDescription
        Address
        City
        State
        Zip
        County
        GPS
        Acreage
        TaxYear
        TotalAssessedValue
        TotalMarketValue
        ReportedOwner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const lDSpropertiesByCountyAndTotalAssessedValue = /* GraphQL */ `
  query LDSpropertiesByCountyAndTotalAssessedValue(
    $County: String!
    $TotalAssessedValue: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLDSpropertyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    LDSpropertiesByCountyAndTotalAssessedValue(
      County: $County
      TotalAssessedValue: $TotalAssessedValue
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        APN
        AssetCategory
        LandUseDescription
        Address
        City
        State
        Zip
        County
        GPS
        Acreage
        TaxYear
        TotalAssessedValue
        TotalMarketValue
        ReportedOwner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
